module.exports = __webpack_public_path__ + "img/pic-1.b8c0c6f2.png";